import { Grid, Input, TextInput } from "@mantine/core";

import { CallToAction } from "@/components/CallToAction";
import { IMaskInput } from "react-imask";

interface AddressFormProps {
  addressForm: any;
  onSubmit: () => void;
  handleFindAddressByCep: (cep: string) => void;
}

export function AddressForm({
  addressForm,
  onSubmit,
  handleFindAddressByCep,
}: AddressFormProps) {
  return (
    <Grid component="form" onSubmit={onSubmit}>
      <Grid.Col span={{ md: 12 }}>
        <Input.Wrapper
          label="CEP"
          withAsterisk
          {...addressForm.getInputProps("zipCode")}
        >
          <Input
            component={IMaskInput}
            mask="00000-000"
            placeholder="Insira seu CEP"
            {...addressForm.getInputProps("zipCode")}
            onAccept={(v: string) => {
              handleFindAddressByCep(v);
            }}
          />
        </Input.Wrapper>
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <TextInput
          withAsterisk
          label="Bairro"
          placeholder="Insira o nome do bairro"
          {...addressForm.getInputProps("neighborhood")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <TextInput
          withAsterisk
          label="Rua"
          placeholder="Insira o nome da rua"
          {...addressForm.getInputProps("street")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <TextInput
          withAsterisk
          label="Número"
          placeholder="Número"
          {...addressForm.getInputProps("number")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <TextInput
          label="Complemento"
          placeholder="Complemento"
          {...addressForm.getInputProps("complement")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <TextInput
          withAsterisk
          label="Cidade"
          placeholder="Insira sua cidade"
          {...addressForm.getInputProps("city")}
        />
      </Grid.Col>
      <Grid.Col span={{ md: 12 }}>
        <TextInput
          withAsterisk
          label="Estado"
          placeholder="UF"
          {...addressForm.getInputProps("state")}
        />
      </Grid.Col>

      <Grid.Col span={{ md: 12 }}>
        <CallToAction w="100%">Salvar Endereço</CallToAction>
      </Grid.Col>
    </Grid>
  );
}
